import { Box, FormControlLabel, Radio, Typography } from '@mui/material';
import React from 'react';
import { spaces, borderRadius, palette, boxShadows } from '../../assets/styles/themes/tokens';
import { colors } from '../../assets/styles/themes/variables';

interface RadioButtonProps {
    option: {
        value: string;
        label: string;
    };
    selected?: boolean;
}

const RadioButton: React.FC<RadioButtonProps> = ({ option, selected = false }) => {
  return (
    <Box
      key={option.value}
      sx={{
        display: 'flex',
        padding: `${spaces.sm} ${spaces.lg} ${spaces.lg} ${spaces.lg}`,
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: spaces.xxs,
        flex: '1 0 0',
        borderRadius: borderRadius.sm,
        border: `1px solid ${selected ? palette.primary.main : palette.elevation.enabled}`,
        background: selected ? palette.primary.main : colors.neutral0,
        boxShadow: boxShadows.elevation3,
      }}
    >
      <FormControlLabel
        value={option.value}
        control={<Radio sx={{ 
          color: selected ? colors.neutral0 : palette.action.active,
          '&.Mui-checked': {
            color: colors.neutral0
          }
        }} />}
        label={
          <Typography 
            variant='h6' 
            sx={{ 
              color: selected ? colors.neutral0 : palette.text.primary, 
              marginTop: spaces.xxs,
              textAlign: 'center',
              width: '100%'
            }}
          >
            {option.label}
          </Typography>
        }
        labelPlacement='bottom'
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: '100%',
          margin: 0
        }}
      />
    </Box>
  );
};

export default RadioButton;
